import AccedanApi from '../api/AccedanApi';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {setModalContent} from '../actionCreators';
import Modal from '../components/Modal';
import BasePage from './BasePage';
import $ from 'jquery';
import logo from '../img/logo.png';

class Login extends BasePage {

    loadOnConstructor(){
        this.loginForm = this.loginForm.bind(this);
        this.loginCallBack = this.loginCallBack.bind(this);

        this.state = {};
        this.getCommonInterface(this.getCommonInterfaceCallback);
    }

    render() {
        return (
<>
<div className="wrapper fadeInDown">
  <div id="formContent">

    <div className="fadeIn first">
      <img alt="" src={logo} id="icon" />
    </div>

    <form onSubmit={this.loginForm} className="mt-4">
      <input type="text" id="email" className="fadeIn second login" name="email" placeholder="email" ref={(c) => this.email = c} />
      <input type="password" id="password" className="fadeIn third login" name="password" placeholder="password" ref={(c) => this.password = c} />
      <input type="submit" className="fadeIn fourth mt-4 login" value="Login" />
    </form>

    <div id="formFooter">
      <Link className="underlineHover" to={'/recover_password'}>{this.getTrad('passwordForgotten')}</Link>
    </div>

  </div>
</div>
<Modal/>
</>
        )
    }

    loginForm(e){
        e.preventDefault();
        const api = new AccedanApi();
        const arrayParams = [
            {name: "email", value: this.email.value}, 
            {name: "password", value: this.password.value}, 
        ];
        api.login(arrayParams, this.loginCallBack);
    }

    loginCallBack(response){
        if(response === undefined){
		this.props.setModalContent({
			title: 'Mensaje del servidor',
			body: ['No se ha podido establecer conexi&oacute;n con el servidor'],
			buttons: [
				{shown: 'Aceptar', behaviour: 'main', close: true}
			]
		});

            	$("#exampleModal").modal('toggle');
            	return;
        }
        
        if(response.auth === false){
		this.props.setModalContent({
			title: this.getTrad('messageFromServer'),
			//body: ['Hubo un problema con la autenticación, las credenciales no son correctas.'],
			body: [this.getTrad('authenticationProblem')],
			buttons: [
				{shown: 'Aceptar', behaviour: 'main', close: true}
			]
		});
		$("#exampleModal").modal('toggle');
            	return;
        }

        if(response.auth === true){
            localStorage.setItem("token", response.token);
            localStorage.setItem("user", JSON.stringify(response.user));
            
            this.props.history.push('/dashboard');
        }
    }
}


const mapStateToProps = state => {
    return {
	username: state.username
    };
}

const mapDispatchToProps = dispatch => {
    return {
        setModalContent(modalContent){
	    dispatch(setModalContent(modalContent));
	}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
